import {
  Box,
  Typography,
  Grid,
  TextField,
  Button,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Stack,
  Chip,
  IconButton,
  Tooltip,
} from "@mui/material";
import {
  Add,
  Search,
  Visibility,
  AssignmentInd,
  Edit,
  ListAlt,
} from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../services/api";
import { useAuth } from "../../../context/AuthContext";
import { useProtectedRoute } from "../../../hooks/useProtectedRoute";

export default function EmployeesListPage() {
  useProtectedRoute();
  const { token } = useAuth();
  const navigate = useNavigate();

  const [employees, setEmployees] = useState<any[]>([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const res = await api.get("employees", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setEmployees(res.data);
      } catch {
        alert("Failed to load employees");
      }
    };
    fetchEmployees();
  }, [token]);

  const filteredEmployees = employees.filter((emp) =>
    [emp.fullName, emp.nationalId, emp.phone, emp.position]
      .join(" ")
      .toLowerCase()
      .includes(search.toLowerCase())
  );

  const formatDate = (date: string) =>
    new Date(date).toLocaleDateString();

  return (
    <Box p={4}>
      {/* Top Header */}
      <Grid container justifyContent="space-between" alignItems="center" mb={3}>
  <Grid item>
    <Typography variant="h4" fontWeight="bold" color="primary">
      HR Module – Employees
    </Typography>
  </Grid>
  <Grid item>
    <Stack direction="row" spacing={2}>
      <Button
        variant="outlined"
        startIcon={<ListAlt />}
        onClick={() => navigate("/hr/contracts")} // ✅ FIXED
      >
        View Contracts
      </Button>
      <Button
        variant="contained"
        color="primary"
        startIcon={<Add />}
        onClick={() => navigate("/hr/employees/add")} // ✅ FIXED
      >
        Add Employee
      </Button>
    </Stack>
  </Grid>
</Grid>


      {/* Search */}
      <Box mb={3}>
        <TextField
          fullWidth
          placeholder="Search by name, ID, phone, position..."
          variant="outlined"
          size="small"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          InputProps={{
            endAdornment: <Search />,
          }}
        />
      </Box>

      {/* Table */}
      <TableContainer component={Paper} elevation={2}>
        <Table size="small">
          <TableHead sx={{ backgroundColor: "#f3f4f6" }}>
            <TableRow>
              <TableCell><strong>Name</strong></TableCell>
              <TableCell><strong>National ID</strong></TableCell>
              <TableCell><strong>Phone</strong></TableCell>
              <TableCell><strong>Position</strong></TableCell>
              <TableCell><strong>Start</strong></TableCell>
              <TableCell><strong>Status</strong></TableCell>
              <TableCell align="right"><strong>Actions</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredEmployees.map((emp) => (
              <TableRow key={emp._id} hover>
                <TableCell>{emp.fullName}</TableCell>
                <TableCell>{emp.nationalId}</TableCell>
                <TableCell>{emp.phone}</TableCell>
                <TableCell>{emp.position}</TableCell>
                <TableCell>{formatDate(emp.startDate)}</TableCell>
                <TableCell>
                  <Chip
                    label={emp.status}
                    size="small"
                    sx={{
                      textTransform: "capitalize",
                      fontWeight: 600,
                      color: "#fff",
                      backgroundColor:
                        emp.status === "active" ? "#10b981" : "#ef4444",
                    }}
                  />
                </TableCell>
                <TableCell align="right">
                  <Stack direction="row" spacing={1} justifyContent="flex-end">
                    <Tooltip title="View Profile">
                      <IconButton
                        color="primary"
                        onClick={() => navigate(`hr/employees/:id`)}
                      >
                        <Visibility fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="View Contract">
                      <IconButton
                        color="secondary"
                        onClick={() => navigate(`/contracts?employeeId=${emp._id}`)}
                      >
                        <AssignmentInd fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Edit Employee (Coming Soon)">
                      <IconButton disabled>
                        <Edit fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </Stack>
                </TableCell>
              </TableRow>
            ))}
            {filteredEmployees.length === 0 && (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  No employees found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
